
import Vue from 'vue';

const ACTIVE = 'primary';
const DEACTIVE = 'outline-primary';

export default Vue.extend({
  computed: {
    view(): string {
      return this.$store.state['insights'].filters.view;
    },
    dailyVariant() {
      if (this.view === 'day') {
        return ACTIVE;
      }
      return DEACTIVE;
    },
    monthlyVariant() {
      if (this.view === 'month') {
        return ACTIVE;
      }
      return DEACTIVE;
    },
  },
  mounted() {
    const q = this.$route.query;
    if (q.groupby) {
      this.$store.dispatch('insights/setGroupBy', q.groupby);
    }
    if (q.view) {
      this.$store.dispatch('insights/setView', q.view);
    }
  },
  methods: {
    toogleView() {
      let req = 'day';
      if (this.view === 'day') {
        req = 'month';
      }
      this.$store.dispatch('insights/setView', req);
      this.$router.push({
        query: Object.assign({}, this.$route.query, { view: req }),
      });
    },
  },
});
